/* eslint-disable new-cap */
import Layout from "../../../components/Layout";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { httprequest } from "../../../data/api";
import BreadCrumb from "../../../components/BreadCrumb";
import { useUserState } from "../../../context/UserContext";
import Button from "../../../components/Button";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Template1 from "../Template/SessionTemplate";
import Template2 from "../Template/SessionTemplate2";
import Template3 from "../Template/SessionTemplate3";

const GET_STUDENT_GRADE = "/api/v1/session-report/student/";

const StudentSessionReport = () => {
  const { id } = useParams();
  const { appLogo, profile } = useUserState();
  const [classGrades, setClassGrades] = useState([]);
  const [scores, setScores] = useState([]);
  const [allTerms, setAllTerms] = useState([]);
  const [attendance, setAttendance] = useState([]);
  const [extraData, setExtraData] = useState([]);
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const reportTemplateRef = useRef(null);

  const handleGetAllClassResult = async () => {
    try {
      const res = await httprequest.get(`${GET_STUDENT_GRADE}${id}`);
      const payload = res?.data?.data || {};
      const subjects = payload.subjects || [];
      const attendanceData = payload.attendance || [];
      const extra = payload.extras || [];

      const allTermMap = new Map();
      const transformedScores = subjects.map((subject) => {
        const termScores = {};
        subject.term_scores?.forEach((term) => {
          termScores[term.term_id] = term.score;
          allTermMap.set(term.term_id, { id: term.term_id, name: term.term_name });
        });

        return {
          subject: subject.name,
          termScores,
          average: subject.average || "--",
          grade: subject.grade || "--"
        };
      });

      setScores(transformedScores);
      setClassGrades(payload);
      setAttendance(attendanceData);
      setAllTerms(Array.from(allTermMap.values()));
      setExtraData(extra);
    } catch (err) {
      toast.error(err?.response?.message || err.message || "Failed to fetch class results");
    }
  };

  const generatePDF = async () => {
    if (!reportTemplateRef.current) return;

    setIsGeneratingPDF(true);
    try {
      const originalStyles = {
        overflow: document.body.style.overflow
      };

      document.body.style.overflow = "hidden";

      const canvas = await html2canvas(reportTemplateRef.current, {
        scale: 1.2,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
        scrollY: -window.scrollY,
        onclone: (clonedDoc) => {
          const images = clonedDoc.querySelectorAll("img");
          images.forEach(img => {
            img.style.maxWidth = "100%";
            img.style.height = "auto";
          });
        }
      });

      document.body.style.overflow = originalStyles.overflow;

      const imgData = canvas.toDataURL("image/jpeg", 0.7);

      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4"
      });

      const imgWidth = 210; // A4 width in mm
      const pageHeight = 295; // A4 height in mm
      const imgHeight = canvas.height * imgWidth / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      const studentName = `${classGrades.last_name || "student"}_${classGrades.first_name || "report"}`;
      pdf.save(`${classGrades?.session?.session} ${studentName}_session_report.pdf`);
    } catch (error) {
      toast.error("Failed to generate PDF");
    } finally {
      setIsGeneratingPDF(false);
    }
  };

  const comment = "This section can be used as a remark for a student";

  useEffect(() => {
    handleGetAllClassResult();
  }, []);

  const template = profile?.report_template?.template_id;

  return (
    <Layout children={
      <>
        <div className="breadcrumb-container">
          <div>
            <BreadCrumb
              link_one="/report/session"
              link_one_name="Reports"
              active="Session Report"
              description="View student session report here"
            />
          </div>
        </div>

        <div ref={reportTemplateRef}>
          {template === "template-1" ? (
            <Template1
              comment={comment}
              scores={scores}
              allTerms={allTerms}
              data={classGrades}
              profile={profile}
              attendance={attendance}
              extra={extraData}
              appLogo={appLogo}
            />
          ) : template === "template-2" ? (
            <Template2
              comment={comment}
              scores={scores}
              allTerms={allTerms}
              data={classGrades}
              profile={profile}
              attendance={attendance}
              extra={extraData}
              appLogo={appLogo}
            />
          ) : template === "template-3" ? (
            <Template3
              comment={comment}
              scores={scores}
              allTerms={allTerms}
              data={classGrades}
              profile={profile}
              attendance={attendance}
              extra={extraData}
              appLogo={appLogo}
            />
          ) :
            <Template1
              comment={comment}
              scores={scores}
              allTerms={allTerms}
              data={classGrades}
              profile={profile}
              attendance={attendance}
              extra={extraData}
              appLogo={appLogo}
            />
          }

        </div>

        <div className="flex gap-10 margin-top-30">
          <Button
            variant="primary"
            buttonSize="medium"
            color="btndefault"
            buttonName={isGeneratingPDF ? "Generating PDF..." : "Export Report"}
            onClick={generatePDF}
            disabled={isGeneratingPDF}
          />
        </div>
        {/* <ToastContainer /> */}
      </>
    }
    />
  );
};

export default StudentSessionReport;
